import { api } from './client'

const accountingService = {
  // Chart of Accounts
  getAccounts: (category = '0') => api.get('/accounting/accounts', { category }),
  getAccount: (id) => api.get(`/accounting/accounts/${id}`),
  getAccountBalance: (id) => api.get(`/accounting/accounts/${id}/balance`),
  getAccountRegister: (id, { limit = 50, offset = 0 } = {}) =>
    api.get(`/accounting/accounts/${id}/register`, { limit, offset }),

  // Account Types
  getAccountTypes: () => api.get('/accounting/account-types'),
  getAccountSubtypes: (typeId) => api.get(`/accounting/account-subtypes/${typeId}`),

  // Journal Entries
  getJournalEntries: ({ type = 'None', limit = 50, offset = 0 } = {}) =>
    api.get('/accounting/journal-entries', { type, limit, offset }),
  getJournalEntry: (id) => api.get(`/accounting/journal-entries/${id}`),

  // Reports
  getTrialBalance: () => api.get('/accounting/trial-balance'),
  getProfitAndLoss: (startDate, endDate) => api.get('/accounting/reports/pl', { startDate, endDate }),
  getAccountsReceivable: () => api.get('/accounting/accounts-receivable'),

  // Period
  getCurrentPeriod: () => api.get('/accounting/period'),

  // Checks
  getChecks: (accountId) => api.get('/accounting/checks', accountId ? { accountId } : {}),
}

export default accountingService
